/*
 * validation共通処理mixin
 */
<script>
export default {
	mixins: [
		require('js/common/validate/checkString.mixin.vue'),
		// マネージャーインスタンスアクセス
		require('js/common/vuex/manager/read.mixin.vue'),
	],
	props:[
		'r_messages',
	],
	computed:{
		msg_err:function(){
			if(this.r_messages){
				return this.r_messages;
			}
			return this.manager.r_messages;
		},
	},
	methods: {
		//! 定義にしたがい文字列チェックを行う
		validateDef:function(arrDef){
			/*
			var arrDef=[
				//! text_code null チェック
				{	"type":this.CHKTYPE_NULL,		//!< タイプ
					"value":,						//!< 評価文字列
					"max":null,					//!< 
					"min":null,					//!< 
					"len":null,					//!< 
					"prm":null,
					"err":function(errMessage){}	//!< エラーコールバック
				},
			];*/

			var ret = true;

			for(var key in arrDef){
				var def = arrDef[key];
				var ret = this.checkString(def.type,
									def.value,
									def.max,
									def.min,
									def.len,
									def.prm);
				if(ret == false){// エラー
					var msg = this.getValidateErrString(def.type,
														def.value,
														def.max,
														def.min,
														def.len,
														def.prm);

					if(def.err){
						// エラーコールバックを実行
						def.err(msg);
					}

					ret = false;
				};
			}
			return ret;
		},
		// 指定されたタイプのバリデーションを行う
		validateType : function(type,value,max,min,len,prm){
			var errMessage = "";
			if(type){
				if(Array.isArray(type)){
					for(var key in type){
						var targetType = type[key];
						errMessage += this.doValidateType(targetType,value,max,min,len,prm);
					}
				}else{
					errMessage += this.doValidateType(type,value,max,min,len,prm);
				}
			}
			return errMessage;
		},
		doValidateType : function(type,value,max,min,len,prm){

			var ret = this.checkString(type,
									value,
									max,
									min,
									len,
									prm);

			if(ret) return "";

			return this.getValidateErrString(type,
									value,
									max,
									min,
									len,
									prm);
		},
		//! エラー文字列取得
		getValidateErrString:function(type,value,max,min,len,prm){
console.log("getValidateErrString : type="+type +", max=" + max + " , min=" + min + " , len=" + len);

			var msg = "type is unknown."
			switch(type){
				case this.CHKTYPE_NULL:// Nullチェック
					msg = this.msg_err.required;
					break;
				case this.CHKTYPE_NUMBER:// 数値
					msg = this.msg_err.integer;
					break;
				case this.CHKTYPE_TEXT:
					msg = this.msg_err.not_test;
					break;
				case this.CHKTYPE_CODE:// 
					var code_max = max;
					var code_min = min;
					msg =  sprintf( this.msg_err.between.numeric, 
									(code_min != undefined)?code_min.toString():"",
									(code_max != undefined)?code_max.toString():"");
					break;
				case this.CHKTYPE_DECLEN:// 小数
					var str = this.max.toString().split('.');
					var nLen = str[0]?str[0].length:2; // 整数部の桁数上限
					var fLen = str[1]?str[1].length:0; // 小数部の桁数上限
					msg = sprintf( this.msg_err.decimal_point, 
									(fLen)?fLen.toString():"" )
					break;
				case this.CHKTYPE_TXTLEN://
				case this.CHKTYPE_TXTLEN2://
					// 最大文字数と現在の文字数を表示
					var maxLength = len;
					var str = new String(value);
					if (type == this.CHKTYPE_TXTLEN2) {
						// CRLFをLF一文字としてカウント
						var currentLength = str.replace(/\r?\n/g, '\n').length;
					} else {
						var currentLength = str.length;
					}
					msg = sprintf( this.msg_err.between.max2,
												(maxLength)?maxLength.toString():"" ,
												this.msg_err.unit_text,
												(currentLength)?currentLength.toString():"" ,
												this.msg_err.unit_text
												);
					break;
				case this.CHKTYPE_KANA:
					msg = this.msg_err.em_string;
					break;
				case this.CHKTYPE_TEL:
					msg = this.msg_err.tel_format;
					break;
				case this.CHKTYPE_ALPHANUM:
					msg = this.msg_err.alpha;
					break;
				case this.CHKTYPE_MLINE:
					msg = sprintf(this.r_messages.between.max_char_line,
									(len)?len.toString():"",
									(max)?max.toString():"")
					break;
				case this.CHKTYPE_ZIP:
					msg = this.msg_err.zip;
					break;
				case this.CHKTYPE_DATE:
					msg = this.msg_err.date_format;
					break;
				case this.CHKTIME_MATCH:
					break;
				case this.CHKTYPE_HALF:
					msg = this.msg_err.half;
					break;
				case this.CHKTYPE_WIDE:
					msg = this.msg_err.wide;
					break;
				case this.CHKTYPE_INTEGRAL_NUMBER:// 数値
					msg = this.msg_err.integral_number;
					break;
				case this.CHKTYPE_CODE_STRING:
					const code_max = max;
					const code_min = min;
					msg = sprintf(this.msg_err.between.numeric, (code_min != undefined) ? code_min + "" : "", (code_max != undefined) ? code_max + "" : "");
					break;
				case this.CHKTYPE_IP_ADDRESS:
					// IPアドレス
					msg = this.msg_err.ip_address;
					break;
				case this.CHKTYPE_DATETIME:
					msg = this.msg_err.datetime_format;
					break;
				case this.CHKTYPE_TIME:
					msg = this.msg_err.time_format;
					break;
			}
			return msg;
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/validate/common.mixin.vue